import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';

import Clickable from 'common/Clickable';

import './UnderlineButton.scss';

const UnderlineButton = ({
  onClick,
  t,
  title = t('edit'),
  className = '',
  icon = <></>,
  disabled = false,
}) => {
  const classes = classnames('UnderlineButton', className);

  return (
    <Clickable className={classes} onClick={onClick} title={title} disabled={disabled}>
      {title}
      {icon}
    </Clickable>
  );
};

export default withTranslation()(memo(UnderlineButton));
